import * as $ from 'jquery';

function handleError($field, message)
{
    // Fallback for selectpicker
    var $container = $field,
        $closestContainer = $field.closest('div.form-control');

    if ($closestContainer.length > 0) $container = $closestContainer;

    $container.addClass('is-invalid');
    $container.after( $('<div class="invalid-feedback">').html(message) );

    $container.one('click', function(e) {
        $container.next('div.invalid-feedback').remove();
        $container.removeClass('is-invalid');
    });
}

function createHiddenField(name, value)
{
    var $input = $('<input type="hidden">');
    $input.prop('name', name);
    $input.val(value);

    return $input;
}

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

export default (
    function()
    {
        $('.participant-table').each(function() {
            var $table = $(this);

            var $participant_emails = [];

            $(".participant-table").keyup(function(event) {
                if (event.which === 13) {
                    $(".participant-add").click();
                    return false;
                }
            });

            $('form[name="participantCreate"] input').keydown(function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    return false;
                }
            });

            $table.find('.participant-add').on('click', function(e) {
                e.preventDefault();

                [].forEach.call(document.querySelectorAll('.invalid-feedback'),function(e){
                    e.parentNode.removeChild(e);
                });

                $table.on('click', 'a.participant-del-btn', function(e) {
                    e.preventDefault();

                    var index = $participant_emails.indexOf($(this).parent().prev().text());
                    $participant_emails.splice(index, 1);
                    console.log($participant_emails);

                    $(this).closest('tr').remove();
                });

                var $first_name = $table.find('[name=first_name]'),
                    $last_name = $table.find('[name=last_name]'),
                    $email = $table.find('[name=email]'),
                    row_count = $table.find('tbody > tr').length;

                // Validate
                var has_errors = false;
                if ($first_name.val() === '')
                {
                    handleError($first_name, 'This field is required');
                    has_errors = true;
                }
                if ($last_name.val() === '')
                {
                    handleError($last_name, 'This field is required');
                    has_errors = true;
                }
                if ($email.val() === '')
                {
                    handleError($email, 'This field is required');
                    has_errors = true;
                }

                if (!isEmail($email.val())){
                    handleError($email, 'Incorrect email format');
                    has_errors = true;
                }

                if ($participant_emails.includes($email.val())){
                    handleError($email, 'You already chose this email');
                    has_errors = true;
                }

                if (!has_errors)
                {
                    var data = {
                        first_name: $first_name.val(),
                        last_name: $last_name.val(),
                        email: $email.val()
                    };

                    $participant_emails.push(data.email);

                    var labels = {
                        first_name: $first_name.val(),
                        last_name: $last_name.val(),
                        email: $email.val()
                    };

                    var $row = $('<tr>'),
                        baseFieldName = 'participantlist[' + data.email + ']';

                    $row.append( $('<td>').append(labels.first_name) );
                    $row.append( $('<td>').append(labels.last_name) );
                    $row.append( $('<td>').append( createHiddenField(baseFieldName+'[data]', JSON.stringify(data)) ).append(labels.email) );

                    var $delButton = $('<a href="#" class="btn btn-secondary participant-del-btn">').html('<i class="fa fa-trash-o">')

                    $row.append( $('<td>').append( $delButton ) );

                    $table.find('tbody').append($row);

                    $first_name.val("");
                    $first_name.removeClass('is-invalid');

                    $last_name.val("");
                    $last_name.removeClass('is-invalid');

                    $email.val("");
                    $email.removeClass('is-invalid');

                    $first_name.focus();
                }

            });

        });
    }($)
);
